export default __webpack_public_path__ + "static/media/patient-appointment-file.f94487ff.webp";